<template lang="html">
  <div class="">
    <transition-group name="list" tag="p">
      <div v-for="todo in todos" :key="todo.id">
          <Todo_item :todo="todo" v-on="$listeners"/>
      </div>
    </transition-group>
    <!-- <b-table responsive striped hover :items="todos" :fields="fields" :tbody-tr-class="rowClass">
      <template v-slot:cell(delete)="todo">
        <b-button
          @click="$emit('del-task-app', todo.item.id)"
          class = "font-weight-bold"
          :class = "{'is-complete-but':todo.item.completed}"
          variant = "danger"
          size = "sm"
          pill
          :disabled="todo.item.completed"
          >
            x
        </b-button>
      </template>
      <template v-slot:cell(done)="todo">
          <b-button
            :class = "{'is-complete-but':todo.completed}"
            @click="markComplete(todo.item)"
            variant = "success"
            size = "sm"
            pill
            :disabled="todo.item.completed"
          >
              ✔
          </b-button>
      </template>
      <template v-slot:cell(priotited)="todo">
        <b-col
          :style = "Get_color(todo.item)"
          class = "p-1 rounded align-middle"
          :class = "{'is-complete-but':todo.completed}"
          style="width: 2rem"
          >
            {{ todo.item.priotited }}
        </b-col>
      </template>
    </b-table> -->
  </div>
</template>

<script>
import Todo_item from './Todo_item';

export default {
  name:"Todos_list",
  props: ["todos"],
  components: {
    Todo_item
  },
  data(){
    return {
      fields: [
        {
          key: 'Done',
        },
         {
           key: 'title',
          sortable: true
        },
        {
          key: 'priotited',
          sortable: true
        },
        {
          key: 'deadline',
          sortable: true
        },
        {
          key: 'delete',
        }
        ],
    }
  },
  methods: {
    rowClass(item, type) {
      if (!item || type !== 'row') return
      if (item.completed) return 'text-light table-dark';
    },
    markComplete(id) {
      id.completed = !id.completed
    },
    Get_color(todo){
      let red=0,green=0,blue=0,max=5,
      level=(todo.priotited / max * 100);

      if (level >=50){
        red =255 -Math.round( (level - 50) / 50 * 255);
        green =255;
      }
      else if (level == 0){
          red=230;
          green=230;
          blue=230;
      }
      else {
        red=255;
        green=Math.round(level / 50 * 255);
      }
      return {
        "background-color": "rgb(" + red + "," + green + ", " + blue + ")"
      }
    }
  },
  computed: {
  }
}
</script>

<style lang="css" scoped>
.list-enter-active, .list-leave-active {
  transition: all 1s;
}
.list-enter, .list-leave-to /* .list-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}

.is-complete{
  background: #5d6d7e !important;
  text-decoration: line-through;
}
</style>
